<template>
  <div>
    <verify-phone-component :submitVerificationCode="oobaChallenge" cancelLink="forcechallenge/cancel" logoutLink="forcechallenge/logout" resendLink="authentication/sendverificationcodechallenge" />
  </div>
</template>
<style>
</style>

<script>
  import validation from 'utils/validation-mixin';
  import redirectHandler from 'utils/redirect';
  import Vue from 'vue';
  import verifyphone from '../../SignIn/components/verify-phone';

  Vue.component('verify-phone-component', verifyphone);

  export default {
    mixins: [
      validation
    ],

    data: () => ({
      model: {
        prompt: null,
        answer: null,
        isMFAChallenge: true
      },
      disabled: false,
      oobaChallenge: {
        action: 'forcechallenge/index',
        isOOBARegistration: false
      },
    }),
    methods: {
      async changeVisibility(event) {
        this.$refs.answer.type = event.target.checked ? 'text' : 'password';
      },

      validateBeforeSubmit() {
        this.$validator.reset()
          .then(_ => {
            this.$validator.validateAll().then(result => {
              if (result) {
                this.post();
              }
            });
          });
      }
    }
  };
</script>
